<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('work_permission.title')" class="mb-1"/>
        <work-permission-search
            v-if="!editMode"
            @search="fetchWorkPermissionRequests"
        />

        <div class="col-sm-12 nopads list-container">
            <!-- Add button-->
            <div
                class="data-list-item add my-2"
                @click.stop="addNew"
            >
                <div class="item-img-cont add-title">
                    <i class="fa fa-plus"/>
                </div>
                <div class="item-text-cont">
                    <span class="item-title-add">{{ $t('common.add_new') }}</span>
                    <font-awesome-icon
                        icon="lock"
                        class="card-body-icon"
                    />
                </div>
            </div>
            <work-permission-list
                :work-permissions="workPermissions"
                @rowClicked="editWorkPermission"
            />
        </div>

        <!--     Editor-->
        <base-modal v-if="editMode" hide-footer hide-header @close="close" size="lg">
            <work-permission-editor
                v-if="editMode"
                :work-permission="workPermission"
                @close="close"
                @closeAndUpdate="closeAndUpdate"/>
        </base-modal>

        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workPermissionHelper} from '../mixins/WorkPermissionMixin'
import WorkPermissionEditor from "./WorkPermissionEditor";
import WorkPermissionList from "./WorkPermissionList";
import WorkPermissionSearch from "./WorkPermissionSearch";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'work-permissions',
    components: {BaseModal, Navbar, WorkPermissionEditor, WorkPermissionList, WorkPermissionSearch},
    mixins: [restApi, workPermissionHelper],
    props: {
        isObserver: {
            type: Boolean,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            workPermissions: [],
            editMode: false,
            workPermission: null
        }
    },
    created: function () {
        this.fetchWorkPermissionRequests()
    },
    methods: {
        fetchWorkPermissionRequests: function (params) {
            this.loading = true
            this.restFetchParams(this.workPermissionUrl, params, this.handleResponse, this.onError)
        },
        handleResponse: function (response) {
            this.workPermissions = response.data
            this.loading = false
        },
        onError: function () {
            this.loading = false
            this.results = []
        },
        editWorkPermission: function (workPermission) {
            if (this.isObserver) {
                this.workPermission = this.workPermissions.find(item => item.id === workPermission.id)
                this.editMode = !!this.workPermission
            }
        },
        close: function () {
            this.workPermission = null
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.workPermission = null
            this.workPermissions = []
            this.fetchWorkPermissionRequests()
            this.editMode = false
        },
        addNew: function () {
            this.workPermission = null
            this.editMode = true
        }
    }
}
</script>
